import { IconBounceRight } from "@tabler/icons-react";
import { cn } from "@/lib/utils";
import { LeapWordmark } from "./LeapWordmark";

interface LogoProps {
  showText?: boolean;
  className?: string;
  onHover?: boolean;
}

export const Logo = ({ showText = true, className, onHover = true }: LogoProps) => {
  const hoverClass = onHover ? "group-hover:animate-subtle-bounce" : "";

  return (
    <div className={cn("flex items-end gap-2 group", className)}>
      <IconBounceRight
        className={cn(
          "w-8 h-8 text-brand-teal dark:text-brand-teal transition-transform duration-300",
          hoverClass
        )}
        strokeWidth={1.5}
      />
      {showText && (
        <LeapWordmark size="small" className="transition-all duration-300" />
      )}
    </div>
  );
};
